import { EsriBaseLayer } from '../../layers/esriBaseLayer';
import { BaseLayerOption } from './baseLayerOption';

// ids set before adding to map
export const baseLayerDefaultOptions = [
  new BaseLayerOption('None', () => [
  ]),
  new BaseLayerOption('Streets', () => [
    new EsriBaseLayer('Streets', 'Streets').setEsriType('Streets').toggleable.set(false),
  ]),
  new BaseLayerOption('Topographic', () => [
    new EsriBaseLayer('Topographic', 'Topographic').setEsriType('Topographic').toggleable.set(false),
  ]),
  new BaseLayerOption('National Geographic', () => [
    new EsriBaseLayer('NationalGeographic', 'National Geographic').setEsriType('NationalGeographic').toggleable.set(false),
  ]),
  new BaseLayerOption('Oceans', () => [
    new EsriBaseLayer('Oceans', 'Oceans').setEsriType('Oceans').toggleable.set(false),
    new EsriBaseLayer('OceansLabels', 'Oceans Labels').setEsriType('OceansLabels'),
  ]),
  new BaseLayerOption('Gray', () => [
    new EsriBaseLayer('Gray', 'Gray').setEsriType('Gray').toggleable.set(false),
    new EsriBaseLayer('GrayLabels', 'Gray Labels').setEsriType('GrayLabels'),
  ]),
  new BaseLayerOption('DarkGray', () => [
    new EsriBaseLayer('DarkGray', 'Dark Gray').setEsriType('DarkGray').toggleable.set(false),
    new EsriBaseLayer('DarkGrayLabels', 'DarkGray Labels').setEsriType('DarkGrayLabels'),
  ]),
  new BaseLayerOption('Imagery', () => [
    new EsriBaseLayer('Imagery', 'Imagery').setEsriType('Imagery').toggleable.set(false),
    new EsriBaseLayer('ImageryTransportation', 'Imagery Transportation').setEsriType('ImageryTransportation').hidden.set(true),
    new EsriBaseLayer('ImageryLabels', 'Imagery Labels').setEsriType('ImageryLabels'),
  ]),
  new BaseLayerOption('Imagery Clarity', () => [
    new EsriBaseLayer('ImageryClarity', 'Imagery Clarity').setEsriType('ImageryClarity').toggleable.set(false),
    new EsriBaseLayer('ImageryTransportation', 'Imagery Transportation').setEsriType('ImageryTransportation').hidden.set(true),
    new EsriBaseLayer('ImageryLabels', 'Imagery Labels').setEsriType('ImageryLabels'),
  ]),
  new BaseLayerOption('Imagery Firefly', () => [
    new EsriBaseLayer('ImageryFirefly', 'Imagery Firefly').setEsriType('ImageryFirefly').toggleable.set(false),
    new EsriBaseLayer('ImageryTransportation', 'Imagery Transportation').setEsriType('ImageryTransportation').hidden.set(true),
    new EsriBaseLayer('ImageryLabels', 'Imagery Labels').setEsriType('ImageryLabels'),
  ]),
  new BaseLayerOption('Shaded Relief', () => [
    new EsriBaseLayer('ShadedRelief', 'Shaded Relief').setEsriType('ShadedRelief').toggleable.set(false),
    new EsriBaseLayer('ShadedReliefLabels', 'Shaded Relief Labels').setEsriType('ShadedReliefLabels'),
  ]),
  new BaseLayerOption('Terrain', () => [
    new EsriBaseLayer('Terrain', 'Terrain').setEsriType('Terrain').toggleable.set(false),
    new EsriBaseLayer('TerrainLabels', 'Terrain Labels').setEsriType('TerrainLabels'),
  ]),
  new BaseLayerOption('USA Topo', () => [
    new EsriBaseLayer('USATopo', 'USA Topo').setEsriType('USATopo').toggleable.set(false),
  ]),
  new BaseLayerOption('Physical', () => [
    new EsriBaseLayer('Physical', 'Physical').setEsriType('Physical').toggleable.set(false),
    new EsriBaseLayer('TerrainLabels', 'Physical').setEsriType('TerrainLabels'),
  ]),
];
